export default __webpack_public_path__ + "static/media/94.17632c14.png";